<template>
    <div class="dashboard--wrapper">
        <div class="structure-group">
            <div v-if="userObjects.length === 1" class="graph-group--info">
                <div class="structure-group--info--text--1">
                    <span>{{ currentObject.displayName }}</span>
                </div>
            </div>
            <div v-if="userObjects.length !== 1" class="graph-group--info">
                <select v-model="selectedUserObject" @change="dashboardChanged" id="dashboardFilter_showSelect" class="select select--2">
                    <option v-for="userObject in userObjects" :value="userObject">{{ userObject.displayName }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: "StructureGroup",
    data: function(){
      return {
        selectedUserObject: null
      }
    },
    computed: {
      ...mapState("structure", ["currentObject"]),
      ...mapState("user", ["userObjects"])
    },
    created: function(){
      this.selectedUserObject = this.currentObject;
    },
    methods: {
      dashboardChanged: function(){
        this.$store.commit('structure/setCurrentStructure', this.selectedUserObject);
        this.$store.dispatch('structure/fetchForCurrentObject');
      },
    }
  }
</script>

<style scoped lang="less">
    .dashboard--wrapper{
        padding-bottom: 0 !important;
    }
    .structure-group {
        padding: 10px 42px;
        &--info {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &--text {
                &--1 {
                    font-weight: 500;
                    font-size: 1rem;
                    color: #011736;
                }
            }
            &--icon {
                position: relative;
                top: 3px;
                left: 10px;
                transform: translate(0, -50%);
                width: 19px;
            }
        }
    }
    .select {
        font-weight: 500;
        font-size: 1rem;
        color: #011736;
        background: url('/images/icon-select-1.svg') no-repeat center right 10px;
    }
</style>
